import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { compactNavigation, defaultNavigation, futuristicNavigation, horizontalNavigation } from 'app/mock-api/common/navigation/data';
import {UserService} from "../../../services/user.service";
import {AuthService} from "../../../core/auth/auth.service";

@Injectable({
    providedIn: 'root'
})
export class NavigationMockApi
{
    private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;
    private _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation;
    private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;

    currentUser: any;
    userRoles: [];

    /**
     * Constructor
     */
    constructor(
        private _fuseMockApiService: FuseMockApiService,
        private _userService: UserService,
        private _authService: AuthService
    ) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Register Mock API handlers
     */
    registerHandlers(): void
    {
        this.currentUser = this._userService.getLoggedInUser();
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() => {
                if (this.currentUser && this.currentUser.roles && this.currentUser.roles.includes('dev')){
                } else if (this.currentUser && this.currentUser.roles && this.currentUser.roles.includes('fin-tech')) {
                    this._defaultNavigation = this._defaultNavigation.filter(navItem => {
                        if (navItem.id.includes('employee') || navItem.id.includes('reports')){
                            return navItem;
                        }
                    })
                } else if(this.currentUser && this.currentUser.roles && this.currentUser.roles.includes('admin')){
                    this._defaultNavigation = this._defaultNavigation.filter(navItem => {
                        if (!navItem.id.includes('client') && !navItem.id.includes('template')){
                            return navItem;
                        }
                    })
                } else if(this.currentUser && this.currentUser.roles && this.currentUser.roles.includes('manager')){
                    this._defaultNavigation = this._defaultNavigation.filter(navItem => {
                        if (!navItem.id.includes('client') && !navItem.id.includes('admin') && !navItem.id.includes('template')){
                            return navItem;
                        }
                    })
                }else {
                    this._defaultNavigation = this._defaultNavigation.filter(navItem => {
                        if (navItem.id.includes('employee')){
                            return navItem;
                        }
                    })
                }
                // Fill compact navigation children using the default navigation
                this._compactNavigation.forEach((compactNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === compactNavItem.id )
                        {
                            compactNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill futuristic navigation children using the default navigation
                this._futuristicNavigation.forEach((futuristicNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === futuristicNavItem.id )
                        {
                            futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill horizontal navigation children using the default navigation
                this._horizontalNavigation.forEach((horizontalNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === horizontalNavItem.id )
                        {
                            horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Return the response
                return [
                    200,
                    {
                        compact   : cloneDeep(this._compactNavigation),
                        default   : cloneDeep(this._defaultNavigation),
                        futuristic: cloneDeep(this._futuristicNavigation),
                        horizontal: cloneDeep(this._horizontalNavigation)
                    }
                ];
            });
    }
}
